import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import RadioButton from './RadioButton';

const bem = new BEMHelper('RadioButton');

const propTypes = {
    originalShippingPrice: PropTypes.string,
    finalShippingPrice: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    verticalCenter: PropTypes.bool
};

function RadioButtonWithPrice(props) {
    const { originalShippingPrice, finalShippingPrice, children, verticalCenter, ...rest } = props;

    const priceLabel = finalShippingPrice ? (
        <div className={bem('adjustedShippingPrice', { verticalCenter })}>
            {originalShippingPrice && <span className={bem('wasShippingPrice')}>{originalShippingPrice}</span>}
            <span className={bem('finalShippingPrice')}>{finalShippingPrice}</span>
        </div>
    ) : null;

    return (
        <RadioButton {...rest} additionalLabel={priceLabel} verticalCenter={verticalCenter}>
            {typeof children === 'function' ? children(props) : children}
        </RadioButton>
    );
}

RadioButtonWithPrice.propTypes = propTypes;
export default RadioButtonWithPrice;
